import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Col, Container, Row, Card, Form } from "react-bootstrap";
import { MdContentPaste } from "react-icons/md";
import Nav from "./Navbar";
import Footer from "./Footer";
import SideTab from "./Toolstab";
import {
  FaChartBar,
  FaChevronLeft,
  FaChevronRight,
  FaFileAlt,
  FaSearch,
} from "react-icons/fa";
import serp1 from "../Images/serp1.png";
import serp2 from "../Images/serp2.png";
import pay from "../Images/pay.png";
import ganalytic from "../Images/ganalytic.png";
import { Helmet } from "react-helmet";
const Googleanalytics = () => {
  const jsonLdData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Google Analytics Tools & Insights for Smarter Decisions",
    url: "https://seobix.com/google-analytics",
    description:
      "Track website performance with Google Analytics insights. Monitor active users, analyze traffic, and make data-driven SEO decisions today!",
    publisher: {
      "@type": "Organization",
      name: "Seobix",
      url: "https://seobix.com",
      logo: {
        "@type": "ImageObject",
        url: "https://seobix.com/Images/Backlinks.png",
      },
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Google Analytics",
          item: "https://seobix.com/google-analytics",
        },
      ],
    },
    mainEntity: {
      "@type": "SoftwareApplication",
      name: "Google Analytics",
      applicationCategory: "SEO Tool / Analytics",
      operatingSystem: "Web",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
        category: "Free Analytics Tool",
      },
    },
    inLanguage: "en",
    keywords: [
      "google analytics",
      "analytics google",
      "google analytics website",
      "google data analytics",
      "google analytics for website",
      "how to set up google analytics",
      "traffic google analytics",
      "what is analytics google",
      "google website analytics",
      "google analytics expert",
      "google analytics for seo",
      "google analytics report",
      "google search console vs google analytics",
      "data analytics google",
      "google analytics active users",
      "google analytics checker",
      "google analytics support",
    ],
    mainEntityOfPage: [
      {
        "@type": "Question",
        name: "What is Google Analytics?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Google Analytics is a web analytics service that tracks and reports website traffic, user behavior, and performance metrics.",
        },
      },
      {
        "@type": "Question",
        name: "Why should I use Google Analytics for my website?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Using Google Analytics helps monitor website traffic, analyze user engagement, optimize content, and make data-driven SEO and marketing decisions.",
        },
      },
      {
        "@type": "Question",
        name: "Can Google Analytics help improve SEO?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, Google Analytics provides insights about traffic sources, user behavior, and conversions that can guide SEO optimization and strategy.",
        },
      },
    ],
  };

  return (
    <div>
      <Helmet>
        <title>Google Analytics Tools & Insights for Smarter Decisions</title>
        <meta
          name="description"
          content="Track website performance with Google Analytics insights. Monitor active users, analyze traffic, and make data-driven SEO decisions today!"
        />
        <meta
          name="keywords"
          content="google analytics, analytics google, google analytics website, google data analytics, google analytics for website, how to set up google analytics, traffic google analytics, what is analytics google, google website analytics, google analytics expert, google analytics for seo, google analytics report, google search console vs google analytics, data analytics google, google analytics active users, google analytics checker, google analytics support"
        />
        <link rel="canonical" href="https://seobix.com/google-analytics" />

        <meta
          property="og:title"
          content="Google Analytics Tools & Insights for Smarter Decisions"
        />
        <meta
          property="og:description"
          content="Track website performance with Google Analytics insights. Monitor active users, analyze traffic, and make data-driven SEO decisions today!"
        />
        <meta property="og:url" content="https://seobix.com/google-analytics" />
        <meta property="og:site_name" content="Seobix" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://seobix.com/Images/Backlinks.png"
        />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="600" />
        <meta property="og:locale" content="en_US" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Google Analytics Tools & Insights for Smarter Decisions"
        />
        <meta
          name="twitter:description"
          content="Track website performance with Google Analytics insights. Monitor active users, analyze traffic, and make data-driven SEO decisions today!"
        />
        <meta
          name="twitter:image"
          content="https://seobix.com/Images/Backlinks.png"
        />
        <meta name="twitter:site" content="@seobix" />
        <meta name="twitter:creator" content="@seobix" />

        <script type="application/ld+json">{JSON.stringify(jsonLdData)}</script>
      </Helmet>

      <Nav />
      <Container fluid className="p-0 mt-5">
        <Row className="justify-content-center" style={{ margin: "0" }}>
          <Col md={10}>
            <Row className="justify-content-between">
              <Col md={8}>
                <ContentAnalytics />
              </Col>

              <Col md={3}>
                <div
                  className="mb-5"
                  style={{
                    position: "sticky",
                    top: "100px",
                    zIndex: 10,
                    background: "#f8f9fa",
                    padding: "1rem",
                    borderRadius: "10px",
                  }}
                >
                  <h5
                    className="text-center mb-4"
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.3rem",
                      color: "#fff",
                      backgroundColor: "#799EFF",
                      display: "inline-block",
                      padding: "6px 16px",
                      borderRadius: "0.5rem",
                    }}
                  >
                    🚀 Explore More SEO Tools
                  </h5>
                  <SideTab />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background:
            "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </div>
  );
};

function ContentAnalytics() {
  return (
    <div>
      <Col>
        <h1 className="text-center mb-4" style={{ color: "#441752" }}>
          Google Analytics & SEO Tools Integration by{" "}
          <span style={{ color: "#fc4100" }}>SeoBix</span>
        </h1>

        <Card className="p-4 mb-4 shadow-sm">
          <h4 style={{ color: "#003366" }}>Key Features and Benefits</h4>
          <p>
            One of the biggest advantages of Google Analytics is its ability to
            segment data in meaningful ways. Users can look at traffic from a
            variety of perspectives, including source (organic, referral,
            direct, paid), device type, geography, and user demographics. Such
            segmentation allows marketers to adapt their policies to certain
            target groups and assess the relevance of various campaigns. It also
            boasts real-time reporting from which users can gain instant
            feedback regarding user activity and campaign conversion.
          </p>
        </Card>
        <Plancard />
        <Card className="p-4 mb-4 shadow-sm">
          <h4 style={{ color: "#003366" }}>
            Integration and Conversion Tracking
          </h4>
          <p>
            Google Analytics integrates with various other Google tools such as
            Google Ads, Search Console, and Google Data Studio. This allows for
            end-to-end campaign lapse management from the very first ad click to
            the last conversion. Event tracking monitors user interactions with
            key site elements such as forms, buttons, videos, and downloads.
            Fine tracking allows pinpointing of the exact elements that ensure
            conversions and it identifies the areas that require enhancement.
          </p>
        </Card>
        <div className="d-flex justify-content-center">
          <img
            src={ganalytic}
            alt="Visitor Insights"
            style={{
              maxWidth: "50vw",
              height: "auto",
              marginBottom: "1rem",
            }}
          />
        </div>
        <Card className="p-4 mb-4 shadow-sm">
          <h4 style={{ color: "#003366" }}>
            The Shift to Google Analytics 4 (GA4)
          </h4>
          <p>
            With the availability of Google Analytics 4, the platform adopts a
            more user-centric and event-based tracking approach. GA4 offers
            improved cross-platform tracking, enabling businesses to monitor
            user journeys across websites and mobile apps in a unified view. It
            also uses advanced machine learning models to generate predictive
            insights and identify trends. Businesses that adopt GA4 can leverage
            deeper analytics capabilities to drive smarter, data-informed
            decisions.
          </p>
        </Card>

        <Plancard />

        <h4
          className="text-center mt-4 mb-3"
          style={{
            fontWeight: "bold",
            fontSize: "1.5rem",
            color: "#0A3981",
          }}
        >
          🔧 Related Tools
        </h4>

        <ToolSlider />
        <Specialoffer />
      </Col>
    </div>
  );
}

const relatedTools = [
  {
    name: "Google Trends Insights",
    icon: <FaSearch size={24} color="#0A3981" />,
    desc: "Know what is searching live all over the globe. Know what people are searching in real time so that you can align your content to what is trending themes and trends of the time.",
    href: "/trending-now-on-google",
  },
  {
    name: "Google Analytics Overview",
    icon: <FaChartBar size={24} color="#0A3981" />,
    desc: "Understand how users browse on your site. Bounce rates, track sessions and traffic sources to decide using the data and to optimize the performance.",
    href: "/google-analytics",
  },
  {
    name: "Search Console Monitor",
    icon: <FaFileAlt size={24} color="#0A3981" />,
    desc: "Test your position in Google search engine. Measure clicks, impressions and rankings of keywords in order to discover opportunities and correct index issues.",
    href: "/search-console",
  },
];
const ToolSlider = () => {
  const sliderRef = useRef(null);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollLeft -= 300;
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollLeft += 300;
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <button
        onClick={scrollLeft}
        style={{
          position: "absolute",
          left: "0",
          top: "-9%",
          transform: "translateY(-50%)",
          zIndex: 10,
          backgroundColor: "#799EFF",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        }}
      >
        <FaChevronLeft />
      </button>

      <button
        onClick={scrollRight}
        style={{
          position: "absolute",
          right: "0",
          top: "-9%",
          transform: "translateY(-50%)",
          zIndex: 10,
          backgroundColor: "#799EFF",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        }}
      >
        <FaChevronRight />
      </button>

      <div
        ref={sliderRef}
        className="mb-4"
        style={{
          display: "flex",
          overflowX: "auto",
          padding: "1rem",
          gap: "1rem",
          scrollbarWidth: "none",
          scrollBehavior: "smooth",
        }}
      >
        {relatedTools.map((tool, idx) => (
          <div
            key={idx}
            style={{
              minWidth: "250px",
              flex: "0 0 auto",
              background: "#f4f8ff",
              borderRadius: "12px",
              padding: "1rem",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              textAlign: "center",
              transition: "transform 0.3s",
            }}
          >
            <div style={{ marginBottom: "0.5rem" }}>{tool.icon}</div>
            <h6 style={{ color: "#0A3981", fontWeight: "bold" }}>
              {tool.name}
            </h6>
            <p
              style={{
                fontSize: "0.9rem",
                minHeight: "60px",
                lineHeight: "1.4",
              }}
            >
              {tool.desc
                .split(" ")
                .map((word, i) =>
                  (i + 1) % 7 === 0 ? word + "\n" : word + " "
                )
                .join("")
                .split("\n")
                .map((line, idx) => (
                  <span key={idx}>
                    {line.trim()}
                    <br />
                  </span>
                ))}
            </p>
            <a
              href={tool.href}
              style={{
                color: "#fff",
                backgroundColor: "#799EFF",
                padding: "6px 12px",
                borderRadius: "8px",
                textDecoration: "none",
                display: "inline-block",
                fontWeight: "bold",
              }}
            >
              Try Now →
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};
const Specialoffer = () => {
  return (
    <div
      className="start-now-btn p-2"
      style={{
        background: "#799EFF",
        borderRadius: "24px",
        color: "white",
        textAlign: "center",
        margin: "3rem auto",
        width: "90%",
        maxWidth: "1000px",
        position: "relative",
      }}
    >
      <h2 className="mb-3" style={{ fontSize: "2rem", fontWeight: "bold" }}>
        Let’s do this! Start unlocking powerful backlink insights.
      </h2>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <a
          // href="/register"
          onClick={() => window.open("https://dashboard.seobix.com/", "_blank")}
          style={{
            backgroundColor: "#fff",
            color: "#000",
            padding: "12px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            textDecoration: "none",
            minWidth: "150px",
            textAlign: "center",
          }}
        >
          Start 3 Months Free Trial
        </a>
      </div>

      <p style={{ color: "#fff", marginTop: "20px", fontSize: "14px" }}>
        <b> Full access — No Credit card Needed.</b>
      </p>
    </div>
  );
};
const Plancard = () => {
  const [isYearly, setIsYearly] = useState(false);
  const plans = [
    {
      title: "Free",
      monthly: "$0",
      yearly: "$0",
      Free: "3 Month Free Trial",
      features: ["Limited Access"],
      buttonText: "Buy Plan",
      color: "#e0f2fe",
      border: "#38bdf8",
      image: pay,
    },
    {
      title: "Basic",
      monthly: "$150/mo",
      features: ["5 Projects", "Standard Reports", "Email Support"],
      buttonText: "Buy Plan",
      color: "#e7f5ff",
      border: "#339af0",
      image: pay,
    },
    {
      title: "Standard",
      monthly: "$350/mo",
      features: ["10 Projects", "Advanced Reports", "Priority Support"],
      buttonText: "Buy Plan",
      color: "#e6fcf5",
      border: "#20c997",
      image: pay,
    },
    {
      title: "Premium",
      monthly: "$750/mo",
      features: ["Unlimited Projects", "All Features", "24/7 Support"],
      buttonText: "Buy Plan",
      color: "#fff3bf",
      border: "#fcc419",
      image: pay,
    },
  ];

  return (
    <Container className="my-5">
      <div className="text-center mb-4">
        <h2 style={{ fontWeight: "700", fontSize: "2rem" }}>
          Boost Your SEO With Our Amazing Plans
        </h2>
        <h4 className="font-weight-bold mb-4" style={{ color: "#441752" }}>
          🚀 Improve Your Rankings —{" "}
          <span style={{ color: "#FC4100" }}>
            Try Our Service Free for 3 Months!
          </span>
        </h4>
        <p style={{ color: "#6b7280" }}>
          Flexible pricing plans designed for every stage of your journey
        </p>
        <div className="d-flex justify-content-center mt-4">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontWeight: "500" }}>Monthly</span>

            <div
              className="m-2"
              style={{ transform: "scale(1.5)", transformOrigin: "center" }}
            >
              <Form.Check
                type="switch"
                id="custom-switch"
                checked={isYearly}
                onChange={() => setIsYearly(!isYearly)}
              />
            </div>

            <div className="d-flex align-items-center gap-2">
              <span style={{ fontWeight: "500" }}>Yearly</span>

              <div
                className="start-now-btn mx-3"
                style={{
                  backgroundColor: "#e6f4ea",
                  color: "#2f855a",
                  padding: "6px 12px",
                  borderRadius: "8px solid",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  border: "1px solid #20c997",
                }}
              >
                🎉
                <span style={{ color: "#0B1D51" }}>
                  Get{" "}
                  <span style={{ color: "#0B1D51" }}>
                    <b>30% OFF</b>
                  </span>{" "}
                  on Yearly Plans
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className="g-4 justify-content-center">
        {plans.map((plan, idx) => (
          <Col md={6} lg={3} key={idx}>
            <div style={{ position: "relative" }}>
              {plan.title === "Free" && (
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: 0,
                    right: 0,
                    height: "32px",
                    backgroundColor: "#38bdf8",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    zIndex: 2,
                  }}
                >
                  {plan.Free}
                </div>
              )}

              <Card
                className="p-2"
                style={{
                  backgroundColor: plan.color,
                  border: `2px solid ${plan.border}`,
                  borderRadius: "16px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow:
                    plan.title === "Free"
                      ? "0 12px 28px rgba(56, 189, 248, 0.5)"
                      : "0 4px 12px rgba(0,0,0,0.05)",
                  marginTop: plan.title === "Free" ? "16px" : "0",
                }}
              >
                <Card.Body>
                  <Card.Title style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    {plan.title}
                  </Card.Title>
                  <h3 style={{ fontWeight: "bold", margin: "1rem 0" }}>
                    {isYearly
                      ? plan.title === "Free"
                        ? plan.yearly
                        : (() => {
                            const monthlyPrice = parseFloat(
                              plan.monthly.replace(/[^0-9.]/g, "")
                            );
                            const yearlyRaw = monthlyPrice * 12;
                            const discounted = yearlyRaw * 0.7;
                            return `$${Math.round(discounted)}/yr`;
                          })()
                      : plan.monthly}
                  </h3>
                  <a
                    href="/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      backgroundColor: plan.border,
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "999px",
                      padding: "8px 20px",
                      fontWeight: "600",
                      marginTop: "1rem",
                    }}
                  >
                    {plan.buttonText}
                  </a>

                  <div className="mt-3">
                    <img
                      src={plan.image}
                      alt={plan.title}
                      style={{
                        // width: "15vw",
                        objectFit: "contain",
                        marginBottom: "1rem",
                      }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Googleanalytics;
